import React from 'react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { styled } from 'linaria/react';
import { theme } from '../Theming/Theming';
import { ProductListSubHeader } from './StyledComponents';

const CategoriesWrapper = styled.div`
  width: 100%;
  margin: 3rem 0 2rem;
  > h3 {
    text-align: center;
  }
  > div {
    max-width: 700px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const StyledLink = styled(CategoryLink)`
  text-decoration: none;
  background: ${theme.colors.lightgrey};
  border-radius: 40px;
  padding: 0.7rem 1.5rem;
  margin: 10px;
`;

export const Categories = ({ title, categories, className, ...rest }) => {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <CategoriesWrapper className={className} {...rest}>
      <ProductListSubHeader>{title}</ProductListSubHeader>
      <div>
        {categories.map((category, index) => {
          return (
            <StyledLink key={index} category={category}>
              {category.name}
            </StyledLink>
          );
        })}
      </div>
    </CategoriesWrapper>
  );
};
